/**
 * House icon convention (absorbed from the raven-chatbot rulebook): Lucide,
 * 1.25px stroke declared in the icon's own 24-unit space so it scales with
 * the glyph. Never pin the stroke with vector-effect — under page zoom a
 * pinned stroke stays hairline while everything else grows.
 */
import type { LucideIcon, LucideProps } from 'lucide-react';

export const LUCIDE_STROKE = 1.25;

export function AppIcon({ icon: Icon, size = 18, ...rest }: {
  icon: LucideIcon;
  size?: number;
} & Omit<LucideProps, 'ref'>) {
  return <Icon size={size} strokeWidth={LUCIDE_STROKE} aria-hidden {...rest} />;
}
